import React, { useEffect, useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { FaStar } from "react-icons/fa";
import infoIcon from "../assets/images/infobtnblue.svg";
import { useDispatch } from "react-redux";
import { UserMachineReviewSave } from "../services/ReduxTookit/Slice/UserMachineReviewRedux";
import { commonservices } from "../services/CommonServices";
import SubmitLoading from "../component/common-component/Loaders/SubmitLoading";
import MainpageLoader from "../component/common-component/Loaders/MainpageLoader";

const WriteReviewModal = ({ show, handleClose, payload, getMachineDetail }) => {
  const [reviewForm, setReviewForm] = useState({
    usermachinereviewid: 0,
    machineid: payload?.machineid,
    refmachineid: payload?.refmachineid,
    userrating: 0,
    userreview: "",
    errors: {
      userreview: "",
      ValidationRules: [
        {
          FieldName: "userreview",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
      ],
    },
  });
  const [hover, setHover] = useState(0);
  const [submitLoading, setSubmitLoading] = useState(false);
  const dispatch = useDispatch();

  const handleClick = (value) => {
    setReviewForm((prevState) => ({
      ...prevState,
      userrating: value,
    }));
  };
  const handleSubmit = (e) => {
    setSubmitLoading(true);
    e.preventDefault();
    let obj = commonservices.fnCheckValidationOfObject(reviewForm);
    setReviewForm({
      ...obj.obj,
    });
    if (!obj.isValid) {
      setSubmitLoading(false);
      return;
    }
    let body = {
      usermachinereviewid: reviewForm?.usermachinereviewid,
      machineid: reviewForm?.machineid,
      refmachineid: reviewForm?.refmachineid,
      userrating: parseInt(reviewForm?.userrating),
      userreview: reviewForm?.userreview,
    };
    dispatch(UserMachineReviewSave(body)).then((res) => {
      if (res?.payload?.isValidate) {
        getMachineDetail(payload?.machineid);
        handleClose();
      } else {
      }
      setSubmitLoading(false);
    });
  };

  // Add or remove 'loadtime' class based on MachineLoader

 useEffect(() => {
  if (submitLoading) {
    document.body.classList.add('loadtime');
  } 
  // else {
  //   document.body.classList.remove('loadtime');
  // }

  // Cleanup when component unmounts
  return () => {
    document.body.classList.remove('loadtime');
  };
}, [submitLoading]); // Re-run this effect when MachineLoader changes

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      centered
      className="write-review-model"
      backdrop="static"
    >
      {submitLoading && <MainpageLoader />}
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Write a Review
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <Form.Group>
            <div className="d-flex gap-2 ">
              <Form.Label>Rating</Form.Label>
              <div
                style={{
                  display: "flex",
                  position: "relative",
                  height: "22px",
                  width: "22px",
                }}
              >
                {[1, 2, 3, 4, 5].map((_, index) => {
                  const fullRatingValue = index + 1;
                  const halfRatingValue = index + 0.5;

                  return (
                    <div
                      key={index}
                      style={{ display: "inline-block", position: "relative" }}
                    >
                      {/*                     
                    <FaStar
                      size={30}
                      color={
                        halfRatingValue <= (hover || reviewForm.userrating)
                          ? "#ffc107"
                          : "#e4e5e9"
                      }
                      onMouseEnter={() => setHover(halfRatingValue)}
                      onMouseLeave={() => setHover(0)}
                      onClick={() => handleClick(halfRatingValue)}
                      style={{
                        cursor: "pointer",
                        position: "absolute",
                        clipPath: "inset(0 50% 0 0)",
                      }}
                    /> */}
                      {/* Full Star */}
                      <FaStar
                        size={22}
                        color={
                          fullRatingValue <= (hover || reviewForm.userrating)
                            ? "#ffc107"
                            : "#e4e5e9"
                        }
                        onMouseEnter={() => setHover(fullRatingValue)}
                        onMouseLeave={() => setHover(0)}
                        onClick={() => handleClick(fullRatingValue)}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </Form.Group>
          <Form.Group className="form-group">
            <Form.Label className="common-label">
              Review
              <span className="ms-1 red-color-text">*</span>
            </Form.Label>
            <div className="position-relative">
              <Form.Control
                as="textarea"
                className="common-input"
                style={{ minHeight: "100px" }}
                value={reviewForm.userreview}
                onChange={(e) =>
                  setReviewForm((prevState) => ({
                    ...prevState,
                    userreview: e.target.value,
                  }))
                }
                isInvalid={reviewForm.errors.userreview}
              />
              {reviewForm.errors.userreview && (
                <Form.Control.Feedback type="invalid">
                  <span className="error-message-icon">
                    <img
                      src={infoIcon}
                      alt="infoIcon"
                      title={reviewForm.errors.userreview}
                    />
                  </span>
                </Form.Control.Feedback>
              )}
            </div>
          </Form.Group>
          <Modal.Footer>
            <div className="d-flex gap-2">
              <button
                className="grey-btn w-auto m-0"
                type="reset"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                className="blue-btn w-auto m-0"
                type="submit"
                disabled={submitLoading}
                onClick={handleSubmit}
              >
                {submitLoading ? <SubmitLoading /> : "Submit"}
              </button>
            </div>
          </Modal.Footer>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default WriteReviewModal;
